"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSalesOrderDetailsForCurrentTime = void 0;
const react_1 = require("react");
const useTickReRender_1 = require("../../../../hooks/useTickReRender");
/**
 * Helper hook to determine sales order states that updates over time.
 */
const useSalesOrderDetailsForCurrentTime = (salesOrder) => {
    const tick = (0, useTickReRender_1.useTickReRender)();
    const { retailLocation, placementTime } = salesOrder;
    // whether this order is currently on the same operational day that it was placed.
    // this updated over time such that old orders that lag over time will show extra information.
    const isSameOperationalDay = (0, react_1.useMemo)(() => retailLocation.isOnSameOperationDay(placementTime, tick), [tick]);
    // due states for given sales order
    const isOverdue = (0, react_1.useMemo)(() => salesOrder.overDue, [tick]);
    const isDueNow = (0, react_1.useMemo)(() => salesOrder.dueNow, [tick]);
    const isDueLater = (0, react_1.useMemo)(() => salesOrder.dueLater, [tick]);
    return (0, react_1.useMemo)(() => ({
        isSameOperationalDay,
        isOverdue,
        isDueNow,
        isDueLater
    }), [isSameOperationalDay, isOverdue, isDueNow, isDueLater]);
};
exports.useSalesOrderDetailsForCurrentTime = useSalesOrderDetailsForCurrentTime;
//# sourceMappingURL=useSalesOrderDetailsForCurrentTime.js.map